import { ApigeeDAO } from './apigee.dao';
import { IAppConfig } from '../../store/interfaces/IAppConfig';
import { Observable } from 'rxjs/Observable';
import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG } from '../config';
import { AssociateDataValidator } from './validators/data.validators';
import { DefaultRetryHandler } from './handlers/retry.handlers';
import { HttpClient } from '@angular/common/http';
import { LogService } from '../services/logging.service';
import { CookieService } from 'ngx-cookie-service';

const CLASS_NAME = 'AssociationDao';

@Injectable()
export class AssociationDao extends ApigeeDAO {
  constructor(http: HttpClient, @Inject(APP_CONFIG) appConfig: IAppConfig, log: LogService, cookieService: CookieService) {
    super(CLASS_NAME, http, appConfig, appConfig.associationDAO, new DefaultRetryHandler(), new AssociateDataValidator(), log, cookieService);
  }

  public put(associateData: any, reservationId: string): Observable<any> {
    const url = this.daoConfig.url.replace('{reservationId}', reservationId);
    return this.doPut(url, associateData);
  };
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/daos/association.dao.ts